import styled from 'styled-components'
import { regularGray } from '../styles/colors'
import { Link } from 'react-router-dom'

export const BackLink = styled(Link)`
  position: relative;
  display: block;
  width: 32px;
  height: 32px;
  text-align: center;

  float: left;

  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;

  background: none;
  padding: 0;
  padding-top: 8px;
  margin: 0;
  margin-right: 8px;

  vertical-align: middle;

  box-sizing: border-box;

  transition: background-color 275ms ease;

  &:hover {
    cursor: pointer;

    svg {
      path {
        fill: ${regularGray};
      }
    }
  }
`
